import { useCallback } from "react";
import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { useAuth } from "contexts/Auth/AuthContext";

export const START_CHAT = gql`
  mutation ADIT_START_DISCUSSION(
    $fileId: uuid!
    $theme: String!
    $user: uuid!
  ) {
    insert_declaration_discussion_one(
      object: {
        file_id: $fileId
        discussion_theme: $theme
        creation_user: $user
        #        declaration_messages: {
        #          data: { creation_user: $user, message: $message }
        #        }
      }
    ) {
      discussion_id
      discussion_theme
      file_id
      #      declaration_messages {
      #        creation_user
      #        message
      #      }
      #      declaration_request {
      #        declaration_request_addresses(where: { address_type: { _eq: 4 }}) {
      #            refs
      #        }
      #      }
    }
  }
`;

const useStartChat = () => {
  const { user } = useAuth();
  const [start] = useMutation(START_CHAT);

  const startChat = useCallback(
    async ({ fileId, theme }) => {
      return await start({
        variables: { fileId, theme, user: user?.userId },
      });
    },
    [start, user]
  );

  return startChat;
};

export default useStartChat;
